import { useEffect } from 'react';
import { Tracker } from '../Tracker';
import { trackingContext } from '../constants';

export interface useTrackingProps {
  trackPageLoad?: boolean;
  prefix?: string;
  context?: trackingContext | keyof typeof trackingContext | string;
  group?: string;
  category?: string;
  pageType?: string;
  getCustomerTrackingData?: any;
  [customField: string]: any;
}

export type useTracking = {
  tracker: Tracker;
};

export const useTracking = ({
  trackPageLoad,
  prefix,
  context,
  group,
  category,
  pageType = 'General Pages',
  getCustomerTrackingData,
  ...extraData
}: useTrackingProps): useTracking => {
  const tracker = new Tracker({ context, prefix, group, category, extraData, getCustomerTrackingData });

  useEffect(() => {
    if (trackPageLoad) {
      tracker.trackPageLoad({ pageType });
    }
  }, []);

  return { tracker };
};
